/* eslint-disable */
/* prettier-ignore */

import React from 'react';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Routes } from "react-router";
import theme from "./styles/theme";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Notifications from "./pages/Notifications";
import { NotificationProvider } from "./contexts/NotificationContext";
import ProtectedRoute from "./components/ProtectedRoute";
// import Shopping from "./pages/Shopping";
// import Treatments from "./pages/Treatments";
// import PetHotel from "./pages/PetHotel";
// import Orders from "./pages/Orders";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NotificationProvider>
        <Router>
          <Routes>
            {/* Rota protegida - só acessível se estiver logado */}
            <Route
              path="/home"
              element={
                <ProtectedRoute requireAuth={true}>
                  <Home />
                </ProtectedRoute>
              }
            />

            {/* Rota pública - só acessível se NÃO estiver logado */}
            <Route
              path="/"
              element={
                <ProtectedRoute requireAuth={false}>
                  <Login />
                </ProtectedRoute>
              }
            />

            {/* Outras rotas protegidas podem ser adicionadas aqui */}
            {/* <Route 
              path="/notifications" 
              element={
                <ProtectedRoute requireAuth={true}>
                  <Notifications />
                </ProtectedRoute>
              } 
            /> */}

            {/* Rota catch-all - redireciona baseado na autenticação */}
            <Route
              path="*"
              element={
                <ProtectedRoute requireAuth={true}>
                  <Home />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </NotificationProvider>
    </ThemeProvider>
  );
};

export default App;
